import React from 'react';
import './WhatsAppButton.css';

function WhatsAppButton() {
    const phoneNumber = '+917487095947';
    const message = 'Hi! I would like to book an appointment at Stoneage Spa.';

    const handleClick = () => {
        const url = `https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    return (
        <div className="whatsapp-float" onClick={handleClick}>
            <svg
                className="whatsapp-icon"
                viewBox="0 0 32 32"
                fill="white"
                width="28"
                height="28"
            >
                <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-4.713 1.262 1.262-4.669-0.292-0.508c-1.207-2.100-1.847-4.507-1.847-6.923 0-7.435 6.050-13.485 13.485-13.485s13.485 6.050 13.485 13.485c0 7.435-6.050 13.485-13.485 13.485zM21.305 18.694c-0.372-0.186-2.197-1.083-2.537-1.208-0.341-0.124-0.589-0.186-0.837 0.186s-0.961 1.208-1.179 1.456c-0.217 0.248-0.434 0.279-0.806 0.093s-1.571-0.579-2.991-1.845c-1.107-0.986-1.854-2.203-2.071-2.575s-0.023-0.573 0.163-0.758c0.167-0.166 0.372-0.434 0.558-0.651s0.248-0.372 0.372-0.62c0.124-0.248 0.062-0.465-0.031-0.651s-0.837-2.010-1.147-2.753c-0.303-0.724-0.611-0.625-0.837-0.637-0.217-0.011-0.465-0.013-0.713-0.013s-0.651 0.093-0.992 0.465c-0.341 0.372-1.301 1.270-1.301 3.096s1.332 3.590 1.518 3.838c0.186 0.248 2.625 4.006 6.359 5.617 0.889 0.383 1.583 0.612 2.125 0.783 0.893 0.284 1.707 0.244 2.350 0.148 0.717-0.107 2.197-0.898 2.507-1.766s0.310-1.611 0.217-1.766c-0.093-0.155-0.341-0.248-0.713-0.434z" />
            </svg>
            <span className="whatsapp-tooltip">Chat with us</span>
        </div>
    );
}

export default WhatsAppButton;
